export enum FeaturedCarouselType {
	InlinePlayer = 'InlinePlayer',
	Thumbnail = 'Thumbnail',
	Grid = 'Grid'
}
